import { ListTree } from "lucide-react";
import type { Heading } from "../types/content";

type ChapterNavProps = {
  headings: Heading[];
  activeHeading: string;
  onNavigate?: () => void;
};

export function ChapterNav({ headings, activeHeading, onNavigate }: ChapterNavProps) {
  const topLevel = headings.filter((heading) => heading.depth === 2);

  return (
    <nav className="chapter-nav" aria-label="章节目录">
      <div className="rail-title">
        <ListTree aria-hidden="true" />
        <span>目录</span>
      </div>
      <ol>
        {topLevel.map((heading, index) => (
          <li key={heading.id}>
            <a
              className={activeHeading === heading.id ? "active" : undefined}
              href={`#${heading.id}`}
              onClick={onNavigate}
            >
              <span>{String(index + 1).padStart(2, "0")}</span>
              {heading.text}
            </a>
          </li>
        ))}
      </ol>
      <p className="chapter-count">共 {topLevel.length} 章 · 约 3.1 万字</p>
    </nav>
  );
}
